import { IcoRectangleGroup } from '@components/icons';

export function ColorsPanel() {
  return (
    <div class="flex-1 flex items-center justify-center">
      <div class="text-center p-6">
        <div class="text-gray-400 mb-3">
          <IcoRectangleGroup class="size-12 mx-auto" />
        </div>
        <p class="text-gray-500">Color customization coming soon</p>
      </div>
    </div>
  );
}
